import { useMutation } from "@apollo/client";

import { GqlSettingsEcologicalFunctionTypeObservationTypeUnlinkInput } from "~/__generated__";

import { SettingsFunctionTypeEditRoute_RemoveObservationTypeDocument } from "../mutations.generated";

export default function useSettingsFunctionTypeEditRoute_RemoveObservationType() {
    const [mutate, { loading, error }] = useMutation(SettingsFunctionTypeEditRoute_RemoveObservationTypeDocument);

    const removeFunctionTypeObservationType = async (
        input: GqlSettingsEcologicalFunctionTypeObservationTypeUnlinkInput,
    ): Promise<void> => {
        await mutate({ variables: { input } });
    };

    return {
        removeFunctionTypeObservationType,
        loading,
        error,
    };
}
